import React from 'react';
import FieldLevelHelp from './FieldLevelHelp';

/**
 * Display a Route Number input with popover help text.
 * 
 * @param props.value The route number value
 * @param props.onChange The function to call, passing in the on change event, when the route number value changes
 */
export default function RouteNumberInput({ value, onChange }) {
	const routeNumberLength = value?.length || 0;

	return (
		<div className="row">
			<div className="col-xs-12">
				<label className="control-label" htmlFor="RouteInput">
					Route Number
					<FieldLevelHelp helpText="Provide an ID number if you would like the order to include your internal Patient or Order ID." trigger="hover" large={true} />
				</label>
			</div>
			<div className="col-xs-7 col-sm-4 col-md-3">
				<input
					className="form-control"
					id={`RouteInput`}
					type="text"
					value={value ?? ''}
					onChange={onChange}
					maxLength="15"
					autoComplete="off"
				/>
				<span className="pull-right">
					{routeNumberLength > 0 ? `${routeNumberLength}/15` : <>&nbsp;</>}
				</span>
			</div>
		</div>
	);
}
